const mapSentiment = sentiment => ({
  positive: sentiment.positive,
  neutral: sentiment.neutral,
  negative: sentiment.negative,
})

const mapTopic = topic => ({
  topic_id: topic.topic_id,
  rank: topic.rank,
  name: topic.name,
  note_count: topic.note_count,
  percentage: topic.percentage,
  aggregated_sentiment: topic.aggregated_sentiment,
  is_other: topic.is_other,
})

const mapPayload = payload => ({
  analysis_id: payload.analysis_id,
  language: payload.language,
  total_notes: payload.total_notes,
  sentiment: payload.sentiment ? mapSentiment(payload.sentiment) : payload.sentiment,
  topics: payload.topics ? payload.topics.map(mapTopic) : payload.topics,
})

const mapResponse = response => ({
  state: response.state,
  websocket_url: response.websocket_url,
  payload: response.payload ? mapPayload(response.payload) : response.payload,
})

export const transformResponseGetCustomerNotesAnalysis = response => (response ? mapResponse(response) : response)
